import { ref } from 'vue';
import notify from 'devextreme/ui/notify';

export function usePrintReport() {
    const isPrinting = ref(false);

    async function printReport(url: string, token: string): Promise<boolean> {
        if (isPrinting.value) return false;
        isPrinting.value = true;
        try {
            const resp = await fetch(url, { headers: { Authorization: 'Bearer ' + token } });
            if (resp.ok && resp.headers.get('content-type')?.includes('application/pdf')) {
                const blob = await resp.blob();
                const blobUrl = URL.createObjectURL(blob);
                const win = window.open(blobUrl, '_blank');
                setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
                if (!win) notify('Permiteți pop-up-uri pentru a vizualiza documentul.', 'warning', 4000);
                return true;
            }
            const msg = await resp.text().catch(() => '');
            notify(msg || `Eroare ${resp.status} la generarea raportului.`, 'error', 5000);
            return false;
        } catch {
            notify('Eroare la conectarea cu serverul de rapoarte.', 'error', 4000);
            return false;
        } finally {
            isPrinting.value = false;
        }
    }

    return { isPrinting, printReport };
}
